import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Button, FormHelperText, IconButton, Stack, Typography } from "@mui/material";
import DeleteIcon from "assets/icons/DeleteIcon";
import { modificateRequiredRule } from "helpers/validation/utils";
import { ChangeEvent, useRef } from "react";
import {
  FieldArray,
  FieldValues,
  Path,
  useController,
  UseControllerProps,
  useFieldArray,
  useFormContext,
} from "react-hook-form";

type UploadButtonProps<T extends FieldValues> = {
  label?: string;
  sx?: object;
  accept?: string;
} & UseControllerProps<T>;

const UploadButton = <T extends FieldValues>({
  label = "Загрузить файл",
  sx,
  name,
  rules,
  accept,
  disabled,
}: UploadButtonProps<T>) => {
  const { fieldState } = useController({ name, rules: modificateRequiredRule(rules) });
  const { control } = useFormContext();
  const { remove, fields, replace } = useFieldArray({ control, name, keyName: "fileId" });
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = (event.target.files ? Array.from(event.target.files).map((file) => ({ file })) : []) as FieldArray<
      FieldValues,
      Path<T>
    >;
    replace(files);
  };

  const handleFileRemove = (index: number) => {
    remove(index);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <Stack spacing={2}>
      <Stack
        direction='row'
        spacing={2}
        useFlexGap
        flexWrap='wrap'>
        {fields.map((field, i) => (
          <Stack
            // @ts-expect-error не получается затипизировать
            key={field.file.name}
            direction='row'
            alignItems='center'
            spacing={0.5}
            sx={{
              border: "1px solid",
              borderColor: "primary.main",
              pl: 1,
              borderRadius: 2,
            }}>
            {/* @ts-expect-error не получается затипизировать */}
            <Typography>{field.file.name}</Typography>
            <IconButton
              onClick={() => handleFileRemove(i)}
              color='primary'>
              <DeleteIcon />
            </IconButton>
          </Stack>
        ))}
      </Stack>
      <Stack
        alignItems='flex-start'
        spacing={0.5}
        sx={sx}>
        <Button
          variant='contained'
          disabled={disabled}
          startIcon={<UploadFileIcon />}
          onClick={handleUploadClick}>
          {label}
        </Button>
        <input
          type='file'
          ref={fileInputRef}
          style={{ display: "none" }}
          disabled={disabled}
          onInput={handleFileChange}
          accept={accept}
          multiple
        />
        {fieldState.error && <FormHelperText sx={{ color: "error.main" }}>{fieldState.error.message}</FormHelperText>}
      </Stack>
    </Stack>
  );
};

export default UploadButton;
